import { type Theme } from "@mui/material";
import { dashIfEmpty } from "../../../constants/utils";
import type { ServiceLevel } from "../../../services/prePlanningService.types";

export const formatTrailerTitle = (
  name?: string | null,
  title?: string | null
) =>
  dashIfEmpty(
    name ? name + (title && name !== title ? " " + title : "") : title ?? ""
  );

export const isMexicoLTLService = (
  isMexicoTooltipEnabled: boolean,
  serviceLevel?: ServiceLevel | null
): boolean => serviceLevel === "MXUS-LTL" && isMexicoTooltipEnabled;

export const daysOnHandColors = (
  daysOnHand: number,
  theme: Theme
): { backgroundColor: string; labelColor: string } => {
  const bgColors = {
    late: theme.palette.customError.light,
    warn: theme.palette.customWarning.light,
    early: theme.palette.customSuccess.light,
  };
  const labelColors = {
    late: theme.palette.customError.main,
    warn: theme.palette.customWarning.main,
    early: theme.palette.customSuccess.main,
  };
  if (daysOnHand >= 4) {
    return { backgroundColor: bgColors.late, labelColor: labelColors.late };
  } else if (daysOnHand >= 2 && daysOnHand <= 3) {
    return { backgroundColor: bgColors.warn, labelColor: labelColors.warn };
  } else if (daysOnHand >= 0 && daysOnHand <= 1) {
    return { backgroundColor: bgColors.early, labelColor: labelColors.early };
  } else {
    return {
      backgroundColor: theme.palette.grey[300],
      labelColor: theme.palette.grey[500],
    };
  }
};

/**
 * Copies the given text to the clipboard using the modern Clipboard API.
 *
 * @param {string} text - The text to copy.
 * @returns {Promise<boolean>} - Resolves to true on success, false on failure.
 */
export const copyToClipboard = async (text?: string | null) => {
  if (!text) return false;

  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};
